module.exports = ".datefilter [class^=\"ft-icon-\"]:before,\n.datefilter [class*=\" ft-icon-\"]:before {\n  font-family: 'mydatepicker' !important; }\n\nlabel {\n  margin-right: 10px;\n  position: relative;\n  margin-left: 5px; }\n\n.work_option {\n  margin-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/calendar-filter/calendar-filter.component.scss
// module id = ./src/app/pages/calendar-filter/calendar-filter.component.scss
// module chunks = main